import { render } from "./PlanningExam.vue?vue&type=template&id=97259176&scoped=true"
import script from "./PlanningExam.vue?vue&type=script&lang=js"
export * from "./PlanningExam.vue?vue&type=script&lang=js"

import "./PlanningExam.vue?vue&type=style&index=0&id=97259176&scoped=true&lang=css"

import exportComponent from "/usr/src/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-97259176"]])

export default __exports__